import { useEffect, useState } from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaHeart } from 'react-icons/fa';
import { Link, NavLink } from 'react-router-dom';
import LanguageSwitcher from '../components/LanguageSwitcher';
import useFavorites from '../hooks/useFavorites';
import logo from './logoOFHome.png';
import './Navbars.css';

export default function Navbars() {
  const { t, i18n } = useTranslation();
  const { favorites } = useFavorites();
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 18);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const closeMenu = () => setExpanded(false);
  const isArabic = i18n.language === 'ar';

  return (
    <Navbar expand="xl" expanded={expanded} onToggle={setExpanded} className={`site-navbar${scrolled ? ' is-scrolled' : ''}`}>
      <Container fluid="xl">
        <Navbar.Brand as={Link} to="/" className="site-brand" onClick={closeMenu}>
          <img src={logo} alt="" aria-hidden="true" />
          <span className="site-brand__copy"><strong>{t('footer.homeStyle')}</strong><small>{isArabic ? 'تصميم • إلهام • أناقة' : 'Design • Inspire • Live'}</small></span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="site-navigation" aria-label={isArabic ? 'فتح قائمة التنقل' : 'Open navigation'} />
        <Navbar.Collapse id="site-navigation">
          <Nav className="site-nav mx-auto" onSelect={closeMenu}>
            <Nav.Link as={NavLink} to="/" end>{t('nav.home')}</Nav.Link>
            <NavDropdown title={t('nav.designStyles')} id="design-styles-dropdown">
              <NavDropdown.Item as={NavLink} to="/AllOfLivingRoom">{t('nav.livingRoom')}</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/AllOfKitchen">{t('nav.kitchen')}</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/AllofBedroom">{t('nav.bedroom')}</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/AllofBethroom">{t('nav.bathroom')}</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={NavLink} to="/AlloFContemporary">{t('nav.contemporaryStyles')}</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/AllofElegantLook">{t('nav.elegantLookStyles')}</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title={t('nav.products')} id="products-dropdown">
              <NavDropdown.Item as={NavLink} to="/Furniture">{t('nav.furniture')}</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/Kitchen">{t('nav.kitchen')}</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/Lighting">{t('nav.lighting')}</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/Decor">{t('nav.decor')}</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/Bathroom">{t('nav.bathroom')}</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={NavLink} to="/ProfessionalDesigners">{t('nav.professionalDesigners')}</Nav.Link>
            <Nav.Link as={NavLink} to="/AboutUs">{t('footer.aboutUs')}</Nav.Link>
            <Nav.Link as={NavLink} to="/ContactUs">{t('nav.contactUs')}</Nav.Link>
          </Nav>

          <div className="site-navbar__actions">
            <LanguageSwitcher />
            <NavLink to="/Favorites" className="favorites-link" aria-label={`${t('favorites.title')} (${favorites.length})`} onClick={closeMenu}>
              <FaHeart aria-hidden="true" /><span className="favorites-count">{favorites.length}</span>
            </NavLink>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
